import {booleanAttribute, Component, EventEmitter, Input, Output} from '@angular/core';
import { IconName } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sigecom-button',
  template: `
    <button
      [disabled]="enableLoading || disabled" (click)="this.buttonClicked.emit(true)"
      type="{{ submitButton ? 'submit' : 'button' }}"
      class="flex items-center gap-2 rounded shadow-flat-xl cursor-pointer justify-center whitespace-nowrap
      transition-colors duration-300 disabled:opacity-40 disabled:pointer-events-none {{ class }} px-3 py-1.5"
      [ngClass]="getBaseStyle()"
      [title]="tooltip"
    >
      <div *ngIf="!enableLoading; else showLoading" class="flex gap-2" [ngClass]= "{'py-1' : addPadding}">
        <fa-icon class={{iconClass}} *ngIf="icon && !invertIconPos" [icon]="icon"></fa-icon>
        <span *ngIf="title">{{ title }}</span>
        <fa-icon class={{iconClass}} *ngIf="icon && invertIconPos" [icon]="icon"></fa-icon>
      </div>

      <ng-template #showLoading>
        <sigecom-circle-loading [sizeInRem]="1.5" color="white" />
      </ng-template>
    </button>
  `,
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input({transform:booleanAttribute}) invertIconPos = false;
  @Input() type: ButtonType = 'default';
  @Input({transform: booleanAttribute}) outlined = false;
  @Input() icon?: IconName;
  @Input() iconClass?: string;
  // sm xs md lg xl
  @Input() class?: string;
  @Input() tooltip: string = '';
  @Input() title?: string;
  @Input() disabled: boolean = false;
  @Input() submitButton: boolean = false;
  @Input() enableLoading: boolean = false;
  @Input() addPadding: boolean = false;
  @Output() buttonClicked: boolean | any = new EventEmitter();



  // TODO: buscar features do tailwind para refatorar cód abaixo
  getBaseStyle() {
    const loadingBg = {
      info: 'bg-sigecom-info text-white',
      success: 'bg-sigecom-success text-white',
      danger: 'bg-sigecom-danger text-white',
      warn: 'bg-sigecom-warn text-white',
      default: 'bg-white text-sigecom-gray'
    };
    if (this.enableLoading) {
      return loadingBg[this.type.toLowerCase() as keyof typeof loadingBg] || loadingBg.default;
    }
    switch (this.type.toLowerCase()) {
      case 'info':
        return `${
          this.outlined
          ? `bg-white text-sigecom-info border border-sigecom-info
          hover:bg-sigecom-info hover:text-white transition-colors duration-300`
          : `bg-sigecom-info text-white`
        }`;
      case 'success':
        return `${
          this.outlined
          ? `bg-white text-sigecom-success border border-sigecom-success
          hover:bg-sigecom-success hover:text-white transition-colors duration-300`
          : `bg-sigecom-success text-white`
        }`;
      case 'danger':
        return `${
          this.outlined
          ? `bg-white text-sigecom-danger border border-sigecom-danger
          hover:bg-sigecom-danger hover:text-white transition-colors duration-300`
          : `bg-sigecom-danger text-white`
        }`;
      case 'warn':
        return `${
          this.outlined
          ? `bg-white text-sigecom-warn border border-sigecom-warn
          hover:bg-sigecom-warn hover:text-white transition-colors duration-300`
          : `bg-sigecom-warn text-white`
        }`;
      case 'gray':
        return `${
          this.outlined
          ? `bg-white text-sigecom-warn border border-sigecom-warn
          hover:bg-sigecom-warn hover:text-white transition-colors duration-300`
          : `bg-sigecom-dark-gray2 text-white`
        }`;
      case 'not-selected':
        return `${
          this.outlined
          ? `bg-transparent text-sigecom-warn border border-sigecom-warn
          hover:bg-sigecom-warn hover:text-white transition-colors duration-300`
          : `border border-[#C9C9C9] bg-[#ECEDF2] text-sigecom-gray shadow-lg`
        }`;
      case 'selected':
        return `${
          this.outlined
          ? `bg-transparent text-sigecom-warn border border-sigecom-warn
          hover:bg-sigecom-warn hover:text-white transition-colors duration-300`
          : `border border-[#C9C9C9] bg-white text-sigecom-info shadow-lg`
        }`;
      case 'head':
        return `${
          this.outlined
          ? `bg-transparent text-sigecom-warn border border-sigecom-warn
          hover:bg-sigecom-warn hover:text-white transition-colors duration-300`
          : `bg-sigecom-info text-[#E9CA26] font bold shadow-lg`
        }`;
      case 'void':
        return `${
          `bg-transparent text-sigecom-info border border-sigecom-info border-dashed`
        }`;
      default:
        return `${!this.outlined
          ? `bg-white text-gray-600 hover:bg-gray-600 hover:text-white` : ` hover:bg-gray-600 hover:text-white bg-white text-gray-600 border border-gray-600`}`;
    }
  }
}

export type ButtonType = 'danger' | 'success' | 'info' | 'warn' | 'default' | 'gray' | 'not-selected' | 'selected' | 'head' | 'void';
